import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const shouldConcurrentRender = () => {
  return getGlobalProperty("concurrentRenderer", false);
};
